module.exports = __webpack_public_path__ + "static/img/qrcode.c1878da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qrcode.jpg
// module id = Ftoc
// module chunks = 225